<template>
  <ul class="dropdown">
    <li class="dropdown-li">
      <input type="text"
        ref="searchInput"
        v-model="searchText"
        @keydown.up="prevResult"
        @keydown.down="nextResult"
        placeholder="Search Machine...">
        <i class="fa fa-search clear-button">
    </li>
    <li class="dropdown-li">
      <select
        v-model="current"
        :title="`Selected Machine: ${current}`"
        class="machine-class">
        <template v-if="filteredOptions.length">
          <option v-for="option in filteredOptions" :key="option.id" :value="option.option">
            {{ option.option }}
          </option>
        </template>
        <template v-else>
          <option value="" disabled>No Machine Found</option>
        </template>
      </select>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    name: {
      type: String
    },
    options: {
      type: [Object, Array],
      required: true
    },
    optionKey: {
      type: String,
      default: 'id'
    },
    optionValue: {
      type: String,
      default: 'value'
    },
    orderBy: {
      type: [String],
      default: 'value'
    },
    selected: {
      type: [String, Number],
      default: ''
    },
    required: {
      type: Boolean,
      default:false
    },
    selectRef: {
      type: String,
      default: 'machine'
    },
    searchKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      current: this.selected,
      hoveredIndex: 0,
      searchText: this.searchKey
    }
  },
  computed: {
    // orderedOptions() {
    //     return _.orderBy(this.options, this.orderBy)
    // },
    filteredOptions() {
      let vm = this
      return this.options.filter(function(option) {
        return option[vm.optionValue].toUpperCase().includes(vm.searchText.toUpperCase())
      })
    }
  },
  watch: {
    'current': function() {
      this.$emit('clicked', { 'key': this.name, 'value': this.current, 'search_key': this.searchText });
      // this.searchText = '';
    },
    'selected': function() {
      this.current = this.selected
    },
    'searchKey': function() {
      this.searchText = this.searchKey
    }
  },
  methods: {
    nextResult() {
      if(this.hoveredIndex === this.filteredOptions.length-1){
        return this.hoveredIndex = 0
      }
      this.hoveredIndex = this.hoveredIndex+1;
    },
    prevResult() {
      if(this.hoveredIndex === 0){
        return this.hoveredIndex = this.filteredOptions.length-1
      }
      this.hoveredIndex = this.hoveredIndex-1;
    }
  }
}
</script>
<style lang="scss">
  select.machine-class:-webkit-autofill { background-color: #FFF !important; }
  select.machine-class:focus,
  select.machine-class:focus { outline-color: blue; z-index: 1; }
  .machine-class {
    padding: 2px 3px;
    width: 100%;
    display: block;
    height: 27px;
    line-height: 27px;
    margin: 0px;
    box-sizing: border-box;
    border: none !important;
    outline: 1px solid #333;
    outline-offset: 0px;
    padding-left: 3px;
    place-self: center;
    text-align: left;
    text-align-last: left;
  }
  .select-dropdown {
    margin-bottom: 2px;
    min-height:27px;
    min-width:400px;
    max-width:100%;
    position: relative;
  }
  ul.dropdown {
    width:100%;
    height:auto;
    min-height: 55px;
    max-height: 300px;
    padding: 0;
    margin: 0;
    position: absolute;
    overflow: auto;
    list-style: none;
    z-index: 10001;
    li.dropdown-li {
      background: white;
      border-width:0 1px 1px;
      cursor: pointer;
      display: block;
      position: relative;
      transition: background 0.2s ease-out;
      top:0;
      left:0;
      padding: 0;
      width:100%;
      //height:100%;
      text-align: left;
      &:first-child {
        z-index: 2;
        border-bottom: none;
        min-height: 27px;
        max-height: 27px;
      }
      input {
        border: none;
        margin: 0;
      }
      input[type="text"] {
        background: #fff;
        width: 100%;
        text-align: left; /* for test */
        border-radius: 0;
        outline: 1px solid #333;
        outline-offset: 0px;
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }
  .dropdown-li .clear-button {
    position: absolute;
    top: 3px;
    border-radius: 10px;
    right: 4px;
    z-index: 2;
    border: none;
    height: 18px;
    cursor: default;
    color: black;
    background-color: #d4dadf !important;
    transform: translateX(2px);
    width: 18px;
    font-weight: bold;
    padding: 0 0 0 4px;
  }
</style>